module.exports = __webpack_public_path__ + "img/eric-rothermel-FoKO4DpXamQ-unsplash.773092a4.jpg";